"use client";

import { Facebook, Twitter, Instagram } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-6">
        <div className="h-5 w-16 bg-muted/30 animate-pulse rounded" />
        <div className="h-5 w-16 bg-muted/30 animate-pulse rounded" />
        <div className="h-5 w-16 bg-muted/30 animate-pulse rounded" />
        <div className="h-5 w-16 bg-muted/30 animate-pulse rounded" />
        <div className="h-5 w-16 bg-muted/30 animate-pulse rounded" />
      </div>;
  }
  return <nav className="flex flex-wrap gap-6 justify-center md:justify-start">
      {menuItems.slice(0, 5).map(item => <Link key={item.id} to={item.href || "#"} className="text-sm text-foreground hover:text-primary hover:underline underline-offset-4 transition-colors duration-[var(--duration-medium)]">
          {item.label}
        </Link>)}
      <Link to="https://viddtube.com/privacy-policy" className="text-sm text-foreground hover:text-primary hover:underline underline-offset-4 transition-colors duration-[var(--duration-medium)]">
        Privacy Policy
      </Link>
    </nav>;
}
export default function Footer() {
  return <footer id="footer" className="bg-surface border-t border-border py-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center">
          <div className="text-sm text-muted-foreground text-center md:text-left">All rights reserved © 2026 ViddTube.com</div>

          <MenuProvider menu_id="4" className="flex justify-center">
            <FooterMenuConsumer />
          </MenuProvider>

          <div className="flex gap-4 justify-center md:justify-end">
            <Link to="https://facebook.com" newTab className="text-muted-foreground hover:text-primary transition-colors duration-[var(--duration-medium)]" aria-label="Facebook">
              <Facebook className="size-5" />
            </Link>
            <Link to="https://twitter.com" newTab className="text-muted-foreground hover:text-primary transition-colors duration-[var(--duration-medium)]" aria-label="Twitter">
              <Twitter className="size-5" />
            </Link>
            <Link to="https://instagram.com" newTab className="text-muted-foreground hover:text-primary transition-colors duration-[var(--duration-medium)]" aria-label="Instagram">
              <Instagram className="size-5" />
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}